import { Component, Input, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavBarComponent } from '@hs/ui-core-navbar';

import { VersionService } from '../services/version.service';

@Component({
    selector: 'app-nav-wrapper',
    templateUrl: './nav-wrapper.component.html',
    styleUrls: ['./nav-wrapper.component.scss'],
    imports: [
        NavBarComponent,
        RouterOutlet,
    ],
})
export class NavWrapperComponent implements OnInit {
    private readonly versionService = inject(VersionService);

    @Input() clientCode: string | undefined;

    protected version: string = '';

    ngOnInit(): void {
        this.versionService.getVersion()
            .subscribe({
                next: (v) => {
                    this.version = v;
                },
            });
    }
}
